import { useState, useRef, useEffect } from "react";
import styles from "./Header.module.scss";
import classNames from "classnames/bind";

import logo from '../../../../assets/logo-Photoroom.png'
import defaultAvt from '../../../../assets/chatbot.png'
import { FiMenu, FiX } from 'react-icons/fi';

const cx = classNames.bind(styles);

function Header({ user, onLogout, onSettings }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const menuRef = useRef(null);

    // Đóng menu khi click ra ngoài
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <header className={cx("header")}>
            <div className={cx("header-left")}>
                <img
                    src={logo}
                    alt="Logo"
                    className={cx("logo")}
                    onClick={() => window.location.href = user?.admin ? '/admin' : "/"}
                />
            </div>

            {/* Navigation */}


            <div className={cx("header-right")} ref={menuRef}>
                <button
                    className={cx("menuToggle")}
                    aria-label={navOpen ? "Đóng menu" : "Mở menu"}
                    onClick={() => setNavOpen((v) => !v)}
                >
                    {navOpen ? <FiX /> : <FiMenu />}
                </button>
                <div>
                    {user?.admin ? (
                        <nav className={cx("nav", { navOpen })}>
                            <button onClick={() => { setNavOpen(false); window.location.href = "/admin"; }}>Customer</button>
                            <button onClick={() => { setNavOpen(false); window.location.href = "/account-ads"; }}>Account Ads</button>
                        </nav>
                    ) : (
                        <nav className={cx("nav", { navOpen })}>
                            <button onClick={() => { setNavOpen(false); window.location.href = "/user/detail"; }}>Detail</button>
                            {/* <button onClick={() => window.location.href = "/user/detail"}>Detail</button> */}
                        </nav>
                    )}

                </div>
                <div
                    className={cx("user-info")}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span className={cx("username")}>{user?.fullname}</span>
                    <img
                        src={defaultAvt}
                        alt="Avatar"
                        className={cx("avatar")}
                    />

                </div>

                {menuOpen && (
                    <div className={cx("dropdown-menu")}>
                        <button onClick={onSettings}>Cài đặt</button>
                        <button onClick={onLogout}>Đăng xuất</button>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Header;
